import { useEffect, useContext } from "react";
import { Modal, Button, Row, Col } from "antd";
import Images from "./../../../../asset/exportImages";
import { GlobalState } from "./../../../../context/globalState";
import { trackProductEvent } from '../../../../lib/trackingService';

function MDDone({ dataPayment }) {
  const { isMobile, Helper } = useContext(GlobalState);
  const platform = Helper.getParamUrlByKey("platform");
  const status = +dataPayment?.statusId; // 1 là chưa thanh toán 2 là thanh toán thành công đơn 0 đồng

  // Đã thanh toán sau 5s sẽ load lại page
  useEffect(() => {
    if (status === 2 && platform !== "app") {
      const orderId = dataPayment?.orderCode || dataPayment?.transCode || dataPayment?.code || dataPayment?.order_code || dataPayment?.tran_code || dataPayment?.orderId || dataPayment?.transId || dataPayment?.id || null;
      const amount = Number(dataPayment?.totalAmount || dataPayment?.amount || dataPayment?.fees || 0);
      trackProductEvent("payment_success", {
        order_id: orderId,
        amount: amount,
      });
      trackProductEvent("order_completed", {
        order_id: orderId,
      });
      setTimeout(() => {
        Helper.clearLocal();
        window.location.reload();
      }, 5000);
    }
  }, []);

  const nextPayment = () => {
    const orderId = dataPayment?.orderCode || dataPayment?.transCode || dataPayment?.code || dataPayment?.order_code || dataPayment?.tran_code || dataPayment?.orderId || dataPayment?.transId || dataPayment?.id || null;
    const amount = Number(dataPayment?.totalAmount || dataPayment?.amount || dataPayment?.fees || 0);
    trackProductEvent("payment_initiated", {
      order_id: orderId,
      amount: amount,
    });
    Helper.clearLocal();
    if (platform === "app") {
      window.ReactNativeWebView.postMessage("/gotocart");
    } else {
      window.location.replace(dataPayment?.paymentLink);
    }
  };

  const continueShopping = () => {
    Helper.clearLocal();
    if (platform === "app") {
      window.ReactNativeWebView.postMessage("/gotohome");
    } else {
      window.location.reload();
    }
  };

  return (
    <>
      <Modal
        footer={false}
        open={true}
        centered={false}
        closable={false}
        // onCancel={handelCanCel}
        style={{ minWidth: isMobile ? "" : 345 }}
      >
        <Row gutter={[15, 15]}>
          <Col xs={24}>
            <div style={{ textAlign: 'center' }}>
              <img width={"60px"} height={"60px"} src={Images.ICThanhCong} />
            </div>
          </Col>
          <Col xs={24}>
            <div style={{ textAlign: 'center', fontSize: isMobile ? 18 : 20, color: '#343A40' }}>
              {
                status === 2
                  ?
                  <b>Thanh toán thành công</b>
                  :
                  <b>{platform !== 'app' ? 'Đã thêm đơn hàng thành công' : 'Đã thêm vào giỏ hàng'}</b>
              }
            </div>
          </Col>
          <Col xs={24}>
            {
              status === 2
                ?
                <div style={{ textAlign: 'center', fontSize: isMobile ? 16 : 18, color: '#343A40' }}>
                  Đơn hàng <b>bảo hiểm an gia 247</b> đã được thanh toán <b>thành công</b>.
                </div>
                :
                <div style={{ textAlign: 'center', fontSize: isMobile ? 16 : 18, color: '#343A40' }}>
                  Đơn hàng <b>bảo hiểm an gia 247</b> {platform === 'app' ? 'đã được thêm vào giỏ hàng' : 'đã thêm đơn hàng'} <b>thành công</b>.
                </div>
            }
          </Col>
          {
            status === 1 &&
            <>
              {
                platform === 'app' &&
                <Col xs={12}>
                  <Button
                    onClick={() => continueShopping()}
                    style={{ backgroundColor: status === 1 ? '#F0F2F5' : '#009B4B', height: 44, color: status === 1 ? '#343A40' : '#fff', width: '100%', boxShadow: 'none', fontWeight: 500, borderRadius: 8, border: '0.5px solid #D2D2D2' }}
                    type="primary">
                    Tiếp tục mua hàng
                  </Button>
                </Col>
              }
              <Col xs={platform !== 'app' ? 24 : 12}>
                <Button
                  onClick={() => nextPayment()}
                  style={{ backgroundColor: '#009B4B', height: 44, width: '100%', color: '#fff', fontWeight: 500, borderRadius: 8 }}
                  type="primary">
                  {'Thanh toán ngay'}
                </Button>
              </Col>
            </>
          }
        </Row>
      </Modal >
    </>
  );
}

export default MDDone;
